module.exports = __webpack_public_path__ + "static/js/session.8ca5e1e4.chunk.worker.js"